import { render } from "./companyView.vue?vue&type=template&id=450f3720"
import script from "./companyView.vue?vue&type=script&lang=js"
export * from "./companyView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__